"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _circle, _g, _circle2;
var Info = function Info(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 26 26"
  }, props), _circle || (_circle = /*#__PURE__*/_react.default.createElement("circle", {
    fill: "currentColor",
    cx: "13.4102787",
    cy: "13.0962538",
    r: "12.5"
  })), _g || (_g = /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(9.434814, 11.714111)",
    stroke: "#FFFFFF",
    strokeLinecap: "square",
    strokeWidth: "2.5"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.9492177,1.55491305 L6.3127173,5.91841265",
    id: "Line-2",
    transform: "translate(4.020508, 3.878156) rotate(-315.000000) translate(-4.020508, -3.878156) "
  }))), _circle2 || (_circle2 = /*#__PURE__*/_react.default.createElement("circle", {
    fill: "#FFFFFF",
    cx: "13.5605469",
    cy: "7.95361328",
    r: "2"
  })));
};
var _default = exports.default = Info;